import React from 'react'

import { useRouter } from 'next/router'
import Head from 'next/head'

import ApplicationLayout from 'layouts/application'
import CompareBroker from 'components/comparebroker'
import { ArticleJsonLd } from 'components/shared/schema/article'
import { pageUri } from 'shared/util'
import { FAQPageJsonLd } from 'components/shared/schema/FaqSchema'
import normalizeSlug from 'components/shared/utils/NormalizeSlug'
import { initializeApollo, addApolloState } from 'util/apolloClient'
import { Get_All_BrokersDocument } from 'graphql/generated/types'

const title = ({ broker1, broker2 }) => {
  return ` ${broker1.attributes.name} vs ${
    broker2.attributes.name
  } Broker Comparison: ${new Date().getFullYear()}`
}

const description = ({ broker1, broker2 }) => {
  return `Compare ${broker1.attributes.name} vs ${broker2.attributes.name} demat, trading, brokerage, charges, margin, plans, exposure`
}

const generatePageUrl = ({ broker1Slug, broker2Slug }) => {
  const page_url = `${normalizeSlug(
    broker1Slug.toLowerCase()
  )}_vs_${normalizeSlug(broker2Slug.toLowerCase())}`
  return page_url
}

export default function BrokerCompare(props) {
  const router = useRouter()
  const { asPath } = router
  const { data: brokerData } = props
  const {
    brokers,
    articles,
    all_brokers: allBrokers,
    nav_calculators: navCalculators,
    all_pages: allPages,
  } = brokerData
  const [broker1, broker2] = brokers.data
  const pageTitle = title({ broker1, broker2 })
  const pageDescription = description({ broker1, broker2 })
  let country = {}
  if (broker1.attributes.country.name === 'India') {
    country = { attributes: broker1.attributes.country }
  } else if (broker2.attributes.country.name === 'India') {
    country = { attributes: broker2.attributes.country }
  }
  return (
    <ApplicationLayout
      allBrokers={allBrokers.data}
      navCalculators={navCalculators.data}
      allPages={allPages.data}
      country={country}
    >
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
      </Head>
      <ArticleJsonLd
        url={pageUri(asPath)}
        title={pageTitle}
        description={pageDescription}
      />
      <FAQPageJsonLd articleDataArr={articles.data} />
      <CompareBroker
        brokers={[broker1, broker2]}
        all_brokers={allBrokers.data}
        articles={articles.data}
      />
    </ApplicationLayout>
  )
}

export async function getServerSideProps({ params }) {
  const { slug } = params

  const matches = /(.*)-vs-(.*)/g.exec(slug)
  const broker1Slug = matches[1]
  const broker2Slug = matches[2]

  if (broker1Slug === broker2Slug) {
    return {
      notFound: true,
    }
  }

  const apolloClient = initializeApollo()
  const queryResults = await apolloClient.query({
    query: Get_All_BrokersDocument,
    variables: {
      slug: [broker1Slug, broker2Slug],
      page_url: generatePageUrl({ broker1Slug, broker2Slug }),
      status: 'published',
    },
  })

  const { data } = queryResults
  if (data.brokers.data.length !== 2) {
    return {
      notFound: true,
    }
  }

  return addApolloState(apolloClient, {
    props: { data },
  })
}
